<template>
  <div class="dropdown_wrap">
    <div class="dropdown" :class="{ on: dropdown }">
      <span @click.prevent="clickDropdown">{{ getTitle }}</span>
      <input class="hidden_input" type="text" ref="input" @blur="blurDropdown()" />
      <ul class="dropdown_lst" v-show="dropdown" v-if="data.length > 0">
        <li v-for="row in data" :key="row[keyName]" @click="selectedRow = row; action(row)">{{row[valueName]}}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Dropdown',
  props: {
    title: {
      default: null
    },
    data: {
      default: [],
      type: Array
    },
    keyName: {
      default: 'key',
      type: String
    },
    valueName: {
      default: 'value',
      type: String
    },
    defaultKey: {
      default: ''
    },
    action: {
      default: () => {},
      type: Function
    }
  },
  data () {
    return {
      dropdown: false,
      selectedRow: {}
    }
  },
  computed: {
    getTitle () {
      return this.title ? this.title : Object.keys(this.selectedRow).length > 0 ? this.selectedRow[this.valueName] : this.defaultKey ? this.data.find(row => row[this.keyName] === this.defaultKey)[this.valueName] : this.data[0][this.valueName]
    }
  },
  methods: {
    clickDropdown () {
      this.dropdown = !this.dropdown
      if (this.dropdown) this.$refs.input.focus()
    },
    blurDropdown () {
      setTimeout(() => {
        this.dropdown = false
      }, 200)
    }
  }
}
</script>

<style scoped>
  .dropdown_wrap {
    float: right;
  }
  .dropdown {
    cursor: pointer;
    margin-top: 10px;
    position: relative;
    white-space: nowrap;
  }
  .dropdown .hidden_input {
    width: 0;
    height: 0;
    border: 0;
    padding: 0;
  }
  .dropdown span {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    line-height: 1.0em;
    letter-spacing: -0.03em;
    padding: 12px 18px;
    border-radius: 5.0em;
    border: 1px solid #aaa;
  }
  .dropdown:hover span {
    background: #fff;
  }
  .dropdown.on span {
    border: 1px solid #379339;
    background: #fff;
  }
  .dropdown span:after {
    content: "";
    display: inline-block;
    width: 14px;
    height: 16px;
    background: url('/statics/img/a_arrow.png') no-repeat;
    background-size: contain;
    margin-left: 12px;
    margin-top: 2px;
    transform: rotate(90deg);
    transition: .15s;
  }
  .dropdown.on span:after {
    transform: rotate(-90deg);
    margin-top: 0;
  }
  .dropdown_lst {
    position: absolute;
    right: 0;
    transform: translate(0, 35px);
    display: inline-block;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #379339;
    box-shadow: 0 5px 5px rgba(0,0,0,0.25);
    background: #fff;
    z-index: 10;
    overflow: auto;
    max-height: 25vw;
  }
  .dropdown_lst li {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4em;
    padding: 5px 10px;
    transition: .1s;
  }
  .dropdown_lst li:hover {
    color: #379339;
    background: #f9f9f9;
  }
</style>
